export default {"Link":"LinkItem-module__Link__LoiTE"};